<div class="auth-container" *ngIf="step == 'sign-up'">
    <div class="texture-top"></div>
    <div class="auth-warpper d-flex w-100 h-100 align-items-center justify-content-center">
        <div class="login-component-form position-relative">
            <img class="logo-icon" src="../../../../assets/images/logo-icon.png" alt="logo icon" />

            <div class="form-control">
                <h3 class="algin-center font-bold txt-welcome-back">
                    {{ 'SignUp.Title' | translate: { appName: 'SimulateNow' } }}
                </h3>
                <p class="algin-center line-text">{{ 'SignUp.Detail' | translate }}</p>
                <p class="algin-center line-text">
                    {{ 'SignUp.by' | translate }} <span class="font-bold">{{ validationData?.organization.name }}</span>
                </p>
                <form class="form-auth" [formGroup]="signUpForm" (ngSubmit)="onSignup()">
                    <div class="w-100 p-0 email-input position-relative">
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.95841 13.7917C1.58341 13.7917 1.25355 13.6493 0.968831 13.3646C0.684109 13.0799 0.541748 12.75 0.541748 12.375V1.62504C0.541748 1.23615 0.684109 0.902819 0.968831 0.625041C1.25355 0.347263 1.58341 0.208374 1.95841 0.208374H16.0417C16.4306 0.208374 16.764 0.347263 17.0417 0.625041C17.3195 0.902819 17.4584 1.23615 17.4584 1.62504V12.375C17.4584 12.75 17.3195 13.0799 17.0417 13.3646C16.764 13.6493 16.4306 13.7917 16.0417 13.7917H1.95841ZM9.00008 7.54171L1.95841 2.89587V12.375H16.0417V2.89587L9.00008 7.54171ZM9.00008 6.16671L15.9584 1.62504H2.06258L9.00008 6.16671ZM1.95841 2.89587V1.62504V12.375V2.89587Z"
                                fill="#ACACAC"
                            />
                        </svg>
                        <input
                            type="email"
                            class="input-text disabled"
                            formControlName="email"
                            name="email"
                            placeholder="{{ 'Login.EnterEmail' | translate }}"
                            required
                            readonly
                        />
                    </div>

                    <div class="w-100 p-0 password-input position-relative mb-0">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4.62492 18.4583C4.23603 18.4583 3.9027 18.3159 3.62492 18.0312C3.34714 17.7465 3.20825 17.4097 3.20825 17.0208V8.08329C3.20825 7.68051 3.34714 7.34024 3.62492 7.06246C3.9027 6.78468 4.23603 6.64579 4.62492 6.64579H5.97909V4.77079C5.97909 3.64579 6.37145 2.69093 7.15617 1.90621C7.94089 1.12149 8.88881 0.729126 9.99992 0.729126C11.111 0.729126 12.0589 1.12149 12.8437 1.90621C13.6284 2.69093 14.0208 3.64579 14.0208 4.77079V6.64579H15.3749C15.7638 6.64579 16.0971 6.78468 16.3749 7.06246C16.6527 7.34024 16.7916 7.68051 16.7916 8.08329V17.0208C16.7916 17.4097 16.6527 17.7465 16.3749 18.0312C16.0971 18.3159 15.7638 18.4583 15.3749 18.4583H4.62492ZM7.41659 6.64579H12.5833V4.77079C12.5833 4.03468 12.3333 3.41663 11.8333 2.91663C11.3333 2.41663 10.7221 2.16663 9.99992 2.16663C9.2777 2.16663 8.66659 2.41663 8.16659 2.91663C7.66659 3.41663 7.41659 4.03468 7.41659 4.77079V6.64579ZM4.62492 17.0208H15.3749V8.08329H4.62492V17.0208V17.0208ZM9.99992 14.1666C10.4444 14.1666 10.8228 14.0104 11.1353 13.6979C11.4478 13.3854 11.6041 13.0208 11.6041 12.6041C11.6041 12.1875 11.4478 11.809 11.1353 11.4687C10.8228 11.1284 10.4444 10.9583 9.99992 10.9583C9.55547 10.9583 9.177 11.1284 8.8645 11.4687C8.552 11.809 8.39575 12.1875 8.39575 12.6041C8.39575 13.0347 8.552 13.4027 8.8645 13.7083C9.177 14.0138 9.55547 14.1666 9.99992 14.1666Z"
                                fill="#ACACAC"
                            />
                        </svg>
                        <input
                            matInput
                            [type]="showPassword ? 'text' : 'password'"
                            class="input-text"
                            name="password"
                            [ngClass]="
                                (passwordCtrl.hasError('required') ||
                                    passwordCtrl.hasError('isValidPassword') ||
                                    passwordCtrl.hasError('isValidPassword_notStrong')) &&
                                (passwordCtrl.touched || passwordCtrl.dirty)
                                    ? 'input-error'
                                    : ''
                            "
                            placeholder="{{
                                validationData?.organization?.name
                                    ? ('ChoosePassword' | translate)
                                    : ('EnterPassword' | translate)
                            }}"
                            required
                            formControlName="password"
                            #password
                        />
                        <mat-icon class="password-eye" matSuffix (click)="togglePasswordVisibility()">
                            {{ showPassword ? 'visibility_off' : 'visibility' }}
                        </mat-icon>
                        <mat-error
                            *ngIf="passwordCtrl.hasError('required') && (passwordCtrl.touched || passwordCtrl.dirty)"
                            >{{ 'ValidationMessage.ChoosePassword' | translate }}</mat-error
                        >
                        <mat-error
                            *ngIf="
                                !passwordCtrl.hasError('required') &&
                                passwordCtrl.hasError('isValidPassword') &&
                                (passwordCtrl.touched || passwordCtrl.dirty)
                            "
                            >{{ 'ValidationMessage.IsValidPassword' | translate }}</mat-error
                        >
                        <mat-error
                            *ngIf="
                                !passwordCtrl.hasError('required') &&
                                passwordCtrl.hasError('isValidPassword_notStrong') &&
                                (passwordCtrl.touched || passwordCtrl.dirty)
                            "
                            >{{ 'ValidationMessage.IsValidPassword_notStrong' | translate }}</mat-error
                        >
                    </div>

                    <button type="submit" mat-button class="btn-sign-in">{{ 'Btn_Signup' | translate }}</button>
                    <span class="d-flex justify-content-center already-account"
                        >{{ 'ReadyAccount' | translate
                        }}<a class="go-back-to-sign-in" style="margin-left: 4px" href="/login">{{
                            'LoginNow' | translate
                        }}</a></span
                    >
                </form>
            </div>
        </div>
    </div>
    <div class="texture-bottom"></div>
</div>

<app-signup-profile
    *ngIf="step == 'sign-up-profile'"
    [user]="user"
></app-signup-profile>
